import React from 'react'
import Header from '../../Header'
import Footer from '../../../Footer/Footer'
import ComingSoon from '../../../../../CustomComponents/ComingSoon'

const TrackPackage = () => {
  return (
    <>
    <Header/>
    <ComingSoon/>
    <Footer/>
    </>
  )
}

export default TrackPackage
